import { computed } from 'vue'
import { CSS_CLASSES } from '../constants/checkbox-constants.js'

/**
 * Styling composable for MsCheckbox
 * Xử lý CSS classes và styling logic
 */
export function useCheckboxStyles(props, checkboxState) {
  // Computed: CSS classes cho wrapper label
  const wrapperClasses = computed(() => {
    const classes = [CSS_CLASSES.wrapper]
    if (checkboxState.isReadOnly.value) {
      classes.push(CSS_CLASSES.eventNone)
    }
    return classes
  })

  // Computed: CSS classes cho input control
  const controlClasses = computed(() => CSS_CLASSES.control)

  // Computed: CSS classes cho text label
  const textClasses = computed(() => CSS_CLASSES.text)

  // Computed: Hiển thị label hay không
  const showLabel = computed(() => Boolean(checkboxState.shouldShowLabel.value))

  return {
    wrapperClasses,
    controlClasses,
    textClasses,
    showLabel,
  }
}
